import { metrics } from '@seek/metrics-js';

import { FORMS } from 'src/reducers/forms';
import type { ReduxState, ReduxInjections } from 'src/types';

export const isAppDirty = (state: { forms: ReduxState['forms'] }) =>
  FORMS.map((formName) => state.forms[formName].dirty).indexOf(true) !== -1;

export const beforeUnload = (store: ReduxInjections) => {
  const warn = isAppDirty(store.getState());

  if (
    warn &&
    (window.APP_CONFIG.SEEK_ENV === 'staging' ||
      window.APP_CONFIG.SEEK_ENV === 'prod')
  ) {
    metrics.count('unsaved-changes-displayed');
    return 'You have unsaved changes.';
  }
};

export const detectUnsavedChanges = (store: ReduxInjections) => {
  if (
    document.readyState === 'complete' ||
    document.readyState === 'interactive'
  ) {
    // document is already ready to go
    window.onbeforeunload = () => beforeUnload(store);
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      window.onbeforeunload = () => beforeUnload(store);
    });
  }
};
